import React, { FC } from 'react';

import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import RequisitesContent from '../shared/RequisitesContent';
import { FormShowTemplate, DEFAULT_ERROR_MESSAGE } from 'framework/form';
import { useEmployeeService } from 'domain/shared/employee';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import getRequisitesValidationSchema from '../createupdate/RequisitesValidationSchema';

const EmployeeRequisitesSummary: FC = () => {
  const { updateRequisites, getForUpdate } = useEmployeeService();

  const employeeId = useEmployeeId();
  const { addMessage } = useMessageService('employeePersonalInfoSummary');

  const handleErrorsOnSubmit = () => {
    addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
  };

  if (!employeeId) {
    return null;
  }

  const handleSubmit = async (values: FormFieldsData): Promise<void | object> => {
    return updateRequisites(employeeId, values);
  };
  return (
    <FormShowTemplate
      getDataFunc={() => getForUpdate(employeeId)}
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={getRequisitesValidationSchema}
      messageContext="employeePersonalInfoSummary"
      handleErrorsOnSubmit={handleErrorsOnSubmit}
    >
      <RequisitesContent />
    </FormShowTemplate>
  );
};

export default EmployeeRequisitesSummary;
